import { useDispatch } from "react-redux";
import MapLocationPicker from "./mapLocationPicker";
import { authActions, selectLanguage, selectSuccessUpdateLocation } from "../redux/AuthSlice";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "setup/redux/Hooks";
import { toast } from "react-toastify";
import { Languages } from "app/utils/common/constants";
import { useLocation } from "react-router-dom";

export function ConfirmLocation() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const language = useAppSelector(selectLanguage);
  const rtlMode = language === Languages.ar;
  const successUpdateLocation = useAppSelector(selectSuccessUpdateLocation);
  const location = useLocation();

  const languageParam = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const lang = params.get("language");
    if (!lang) return null;
    const normalized = lang.toLowerCase();
    return normalized === "ar" || normalized === "en" ? normalized : null;
  }, [location.search]);

  useEffect(() => {
    if (languageParam && languageParam !== language) {
      dispatch(authActions.changeLanguage(languageParam));
    }
  }, [languageParam, language, dispatch]);

  useEffect(() => {
    if (successUpdateLocation) {
      toast.success(t("MAP_PICKER.LOCATION_UPDATED_SUCCESS"));
      setTimeout(() => {
        dispatch(authActions.resetUpdateLocationState());
      }, 500);
    }
  }, [successUpdateLocation, dispatch, t]);

  const submitLocation = (coord: any, token: any) => {
    console.log("token", token);
    const data = {
      lat: coord.lat.toString(),
      lng: coord.lng.toString(),
      token,
    };
    dispatch(authActions.updateLocation({
      ...data
    }));
  };
  return (
    <div>
      <MapLocationPicker
        rtl={rtlMode}
        defaultCenter={{ lat: 24.7136, lng: 46.6753 }}
        submitLocation={submitLocation}
      />

    </div>
  )
}
